import React, { ReactNode } from "react";
import { AxiosResponse } from "axios";
import ErrorPage from "./errors/ErrorPage";
import { HttpError } from "./errors/errors";

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  httpStatusCode: number | null;
}

class HttpErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, httpStatusCode: null };
  }

  static getDerivedStateFromError(error: AxiosResponse) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, httpStatusCode: error.status };
  }

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }
    return <ErrorPage code={this.state.httpStatusCode as HttpError} />;
  }
}

export default HttpErrorBoundary;
